var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessBounce(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.31,
    height: 118.701,
    viewBox: "0 0 180.31 118.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success-bounce",
    transform: "translate(-630 -349.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg-styles",
    transform: "translate(630 349.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M478.87,166.987s-2.263-.163-2.039,4.917a62.454,62.454,0,0,0,.727,7.786s-.068,1.128-.938.907-2.515-1.319-3.327-.5-.54,2.155.574,3.691,3.436,4.989,3.643,5.3.289.884-.34.829-4.8-1.471-5.349.551,3.259,5.777,3.667,6.209.432.68.265.938-1.526-.34-2.719-.707-2.661-.554-2.882.639,1.454,4.683,7.741,8.353l3.021,1.509,2.861-1.825c5.886-4.279,7.2-7.922,6.865-9.084s-1.767-.822-2.929-.34-2.454,1.213-2.644.979-.2-.5.17-.962,3.776-4.588,3.025-6.545-4.758-.129-5.373,0-.588-.462-.415-.788,2.138-4,3.1-5.641,1.121-2.967.2-3.738-2.413.52-3.259.829-1.019-.809-1.019-.809a58.74,58.74,0,0,0-.058-7.816c-.3-5.07-2.61-4.683-2.61-4.683",
    transform: "translate(-310.382 -110.408)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M496.35,180.35a.82.82,0,0,1,0,.105,1.686,1.686,0,0,0,.024.313c.02.279.048.68.082,1.2.071,1.04.16,2.549.262,4.418.207,3.738.452,8.883.7,14.575s.476,10.848.663,14.575c.1,1.862.173,3.368.224,4.418.027.517.048.921.061,1.2v.313a1.649,1.649,0,0,0-.024-.309c-.02-.282-.048-.68-.082-1.2-.068-1.043-.16-2.552-.262-4.418-.207-3.738-.449-8.88-.7-14.575s-.479-10.844-.68-14.575c-.1-1.859-.17-3.368-.224-4.418-.024-.517-.044-.921-.058-1.2v-.313A.811.811,0,0,1,496.35,180.35Z",
    transform: "translate(-327.682 -119.234)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M486,210.33a.9.9,0,0,1,.187.156c.116.105.279.262.479.459.4.4.935.955,1.516,1.587l1.478,1.618.452.486a1.079,1.079,0,0,1,.156.187,1.99,1.99,0,0,1-.19-.153c-.119-.105-.279-.265-.476-.466-.394-.4-.924-.965-1.505-1.594L486.608,211l-.452-.486A1.077,1.077,0,0,1,486,210.33Z",
    transform: "translate(-320.855 -139.026)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M499.4,213.37c-.02-.024,1.084-1.179,2.471-2.586s2.528-2.528,2.552-2.5-1.084,1.179-2.471,2.586S499.423,213.39,499.4,213.37Z",
    transform: "translate(-329.701 -137.672)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M499.37,242.557a1.112,1.112,0,0,1,.211-.136l.591-.34c.5-.282,1.186-.68,1.93-1.128s1.4-.89,1.879-1.21l.564-.377a1.161,1.161,0,0,1,.214-.126,1.017,1.017,0,0,1-.187.163c-.129.1-.313.241-.544.408-.466.34-1.121.785-1.869,1.24s-1.441.839-1.951,1.1c-.255.129-.462.231-.608.3A1.088,1.088,0,0,1,499.37,242.557Z",
    transform: "translate(-329.682 -158.111)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M484.63,240a1.848,1.848,0,0,1,.211.1l.547.306c.459.262,1.091.629,1.784,1.043s1.322.792,1.771,1.07l.53.34a.915.915,0,0,1,.184.136.818.818,0,0,1-.207-.1c-.133-.068-.319-.173-.551-.3-.459-.262-1.091-.632-1.784-1.043s-1.319-.792-1.771-1.07c-.224-.139-.4-.255-.527-.34A.886.886,0,0,1,484.63,240Z",
    transform: "translate(-319.952 -158.613)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M481.71,262.77a1.3,1.3,0,0,1,.265.129l.7.387c.591.34,1.4.8,2.3,1.319s1.7,1,2.284,1.359l.68.421a1.541,1.541,0,0,1,.241.166,1.3,1.3,0,0,1-.265-.129l-.7-.387c-.591-.34-1.4-.8-2.3-1.319s-1.7-1-2.28-1.359l-.68-.421A1.357,1.357,0,0,1,481.71,262.77Z",
    transform: "translate(-318.024 -173.645)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M500.39,264.96a1.645,1.645,0,0,1,.265-.177l.734-.449c.618-.377,1.475-.9,2.4-1.505s1.754-1.172,2.352-1.59l.707-.489a1.7,1.7,0,0,1,.265-.17,1.425,1.425,0,0,1-.241.207c-.16.126-.391.306-.68.52-.585.432-1.407,1.02-2.338,1.618s-1.791,1.121-2.423,1.482c-.316.18-.574.34-.754.415a1.837,1.837,0,0,1-.289.139Z",
    transform: "translate(-330.355 -172.199)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M497.513,288.82H489.15l2.729,20.662h2.906Z",
    transform: "translate(-322.935 -190.842)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M490.43,294.6a.123.123,0,0,0,.044.075.5.5,0,0,0,.2.143,1.02,1.02,0,0,0,.884-.105,6.892,6.892,0,0,1,1.084-.717,2.4,2.4,0,0,1,1.539.031,6.668,6.668,0,0,1,1.431.68,10.114,10.114,0,0,0,1.166.625,3.292,3.292,0,0,0,.86.248,1.363,1.363,0,0,0,.241,0h.085a4.284,4.284,0,0,1-1.145-.34,12.156,12.156,0,0,1-1.142-.646,6.376,6.376,0,0,0-1.454-.717,2.467,2.467,0,0,0-1.624-.017,2.142,2.142,0,0,0-.612.377,4.446,4.446,0,0,1-.476.37.989.989,0,0,1-.816.143A.785.785,0,0,1,490.43,294.6Z",
    transform: "translate(-323.78 -194.084)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M491.327,304.532a2.69,2.69,0,0,1,.2-.221,1.871,1.871,0,0,1,.68-.425,3.013,3.013,0,0,1,1.162-.173,11.791,11.791,0,0,1,1.458.2,4.941,4.941,0,0,0,1.488.061,4.1,4.1,0,0,0,1.172-.34,3.8,3.8,0,0,0,.707-.421.856.856,0,0,0,.221-.2,6.7,6.7,0,0,1-.965.534,4.306,4.306,0,0,1-1.149.3,5.1,5.1,0,0,1-1.455-.075,10.906,10.906,0,0,0-1.471-.187,2.968,2.968,0,0,0-1.2.211,1.773,1.773,0,0,0-.68.476.983.983,0,0,0-.126.187C491.334,304.505,491.32,304.529,491.327,304.532Z",
    transform: "translate(-324.371 -200.21)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M498.978,312.368a.679.679,0,0,0-.228-.122,2.5,2.5,0,0,0-.68-.146,4.418,4.418,0,0,0-1.05.058c-.391.065-.809.173-1.247.265a5.125,5.125,0,0,1-1.244.139,2.679,2.679,0,0,1-.989-.211,2.256,2.256,0,0,1-.751-.561.678.678,0,0,0,.143.221,1.757,1.757,0,0,0,.568.425,2.617,2.617,0,0,0,1.019.251,4.838,4.838,0,0,0,1.278-.133c.445-.092.86-.2,1.244-.272a4.73,4.73,0,0,1,1.019-.088A3.714,3.714,0,0,1,498.978,312.368Z",
    transform: "translate(-325.338 -206.006)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M493.5,320.969a1.335,1.335,0,0,1,.812-.082,3.914,3.914,0,0,1,.85.316,3.246,3.246,0,0,0,1.1.3,3.283,3.283,0,0,0,2-.462,2.713,2.713,0,0,0,.5-.387c.1-.109.153-.17.146-.177a6.987,6.987,0,0,1-.68.476,3.4,3.4,0,0,1-1.94.411,15.922,15.922,0,0,1-1.947-.578,1.223,1.223,0,0,0-.632.054C493.554,320.9,493.5,320.963,493.5,320.969Z",
    transform: "translate(-325.806 -211.743)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M494.87,331.372a1.569,1.569,0,0,0,.7-.139c.421-.139.941-.462,1.55-.7a2.58,2.58,0,0,1,.887-.187,1.716,1.716,0,0,1,.717.163,1.557,1.557,0,0,1,.517.445.326.326,0,0,0-.082-.177,1.128,1.128,0,0,0-.391-.34,1.648,1.648,0,0,0-.758-.2,2.555,2.555,0,0,0-.938.184c-.632.251-1.135.585-1.536.744S494.866,331.348,494.87,331.372Z",
    transform: "translate(-326.711 -218.18)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M496.08,338.992a1.933,1.933,0,0,0,.53.17,9.092,9.092,0,0,0,1.322.224,10.1,10.1,0,0,0,1.359.041,1.974,1.974,0,0,0,.554-.068c0-.041-.85,0-1.883-.109S496.09,338.958,496.08,338.992Z",
    transform: "translate(-327.51 -223.961)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M304.952,1.06V17.882H280.79l-.87-16.7Z",
    transform: "translate(-184.809 -0.873)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 16.669,
    height: 24.162,
    transform: "translate(95.111 16.975) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M303.973,17.97H279.58V1.07h24.393Zm-24.162-.231h23.931V1.3H279.811Z",
    transform: "translate(-184.584 -0.88)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 18.929,
    height: 12.526,
    transform: "translate(97.728 2.376)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M306.331,7.368h-5.3L287.4,7.4l.054-.054V19.867h0l-.061-.058h18.929l-.048.048c0-3.81.02-6.936.024-9.114V10.7c0,2.182,0,5.318.024,9.142v.048H287.29v-.061h0V7.314h.054l13.661.027h5.247Z",
    transform: "translate(-189.674 -4.992)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M279.92,1.27a2.005,2.005,0,0,1,.415.268c.248.18.584.432.948.724s.68.564.907.771a1.889,1.889,0,0,1,.34.34c-.02.027-.6-.452-1.329-1.02A13.03,13.03,0,0,1,279.92,1.27Z",
    transform: "translate(-184.809 -1.012)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M345.89,1.41a11.793,11.793,0,0,1-1.271,1.081,11.8,11.8,0,0,1-1.359.989A11.749,11.749,0,0,1,344.531,2.4a11.319,11.319,0,0,1,1.359-.989Z",
    transform: "translate(-226.623 -1.104)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M345.719,46.2,343,44",
    transform: "translate(-226.452 -29.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M343,44a12.92,12.92,0,0,1,1.383,1.047,11.743,11.743,0,0,1,1.336,1.152,13.475,13.475,0,0,1-1.383-1.047A12.133,12.133,0,0,1,343,44Z",
    transform: "translate(-226.452 -29.221)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M279.92,46.479a23.063,23.063,0,0,1,2.59-2.049,10.916,10.916,0,0,1-1.257,1.07A11,11,0,0,1,279.92,46.479Z",
    transform: "translate(-184.809 -29.504)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 4.194,
    height: 11.911,
    transform: "translate(101.572 10.474) rotate(-90)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 21.756,
    height: 36.012,
    transform: "translate(130.692 4.992)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 21.756,
    height: 36.012,
    transform: "translate(129.968 4.992)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 19.904,
    height: 34.551,
    transform: "translate(130.896 5.723)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 12.237,
    height: 25.572,
    transform: "translate(134.685 10.212)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M396.369,60.854a5.419,5.419,0,0,1,4.486-5.053c1.125-.16,2.324.065,3.378-.367,1.883-.771,2.481-3.273,4.374-4.013L408.7,69.9H396.369Z",
    transform: "translate(-261.684 -34.119)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M276.382,118.98,292.5,127.9l-.6,1.138-15.976-9.094.462-.969",
    transform: "translate(-182.168 -78.72)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M274.95,114.3l.741-1.135.432.265-.666,1.145Z",
    transform: "translate(-181.527 -74.877)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M313.21,141.09l.826.479-2.7,17.223-1.278.014Z",
    transform: "translate(-204.706 -93.316)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M299.13,194.867a6.643,6.643,0,0,1,4.6-1.842,5.709,5.709,0,0,1,3.983,1.832Z",
    transform: "translate(-197.491 -127.597)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M262.6,122.521l-6.382-3.684,1.842-3.191a3.687,3.687,0,0,1,5.033-1.359h0a3.684,3.684,0,0,1,1.359,5.033Z",
    transform: "translate(-169.162 -75.298)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 20.451,
    height: 0.996,
    transform: "translate(56.748 66.428) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M146.045,168.045l3.837-14.375H133.913l-3.473,14.375Z",
    transform: "translate(-86.127 -101.621)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M133.26,168.251h14.263l3.32-12.621H136.505Z",
    transform: "translate(-87.989 -102.915)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 1.033,
    height: 49.31,
    transform: "translate(32.245 69.371)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 1.033,
    height: 49.167,
    transform: "translate(33.279 69.51)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 1.033,
    height: 49.31,
    transform: "translate(95.876 69.371)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 1.033,
    height: 49.167,
    transform: "translate(96.909 69.51)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 78.451,
    height: 4.044,
    transform: "translate(27.791 66.506)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 34.537,
    height: 6.695,
    transform: "translate(61.856 70.55)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M234.413,215.1a.771.771,0,1,1-.771-.771A.771.771,0,0,1,234.413,215.1Z",
    transform: "translate(-153.748 -141.666)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M65.235,249.855H78.8a1.73,1.73,0,0,0,1.73-1.73v-4.183a2.912,2.912,0,0,0-2.912-2.912H65.13Z",
    transform: "translate(-43.012 -159.293)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M50.315,269.62H23.642a1.312,1.312,0,0,1-1.312-1.312h0A1.312,1.312,0,0,1,23.642,267H50.315a1.315,1.315,0,0,1,1.315,1.315h0A1.312,1.312,0,0,1,50.315,269.62Z",
    transform: "translate(-14.756 -176.438)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M3.5,163.428l14.674-.258,9.315,35.2-19.867.2L.141,167.71A3.466,3.466,0,0,1,3.5,163.428Z",
    transform: "translate(-0.044 -107.892)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M23.181,274.71,18.79,300.228h1.2l5.77-25.518Z",
    transform: "translate(-12.419 -181.527)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M53.106,274.71,48.44,300.228h1.2l6.046-25.518Z",
    transform: "translate(-31.993 -181.527)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M90.833,274.71l5.206,25.518h-1.2L88.25,274.71Z",
    transform: "translate(-58.274 -181.527)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M48.44,163.17,55.7,198.407h5.566l-5.821-31.136a5.016,5.016,0,0,0-4.931-4.1Z",
    transform: "translate(-31.993 -107.892)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 0.751,
    height: 6.705,
    transform: "translate(3.805 22.878)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 0.751,
    height: 6.705,
    transform: "translate(28.504 22.878)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 31.407,
    height: 2.695,
    transform: "translate(1.035 20.183)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 4.329,
    height: 20.183,
    transform: "translate(21.912)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M70.33,43.986a.856.856,0,1,1-.252-.607A.86.86,0,0,1,70.33,43.986Z",
    transform: "translate(-45.309 -28.646)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 1.325,
    height: 8.248,
    transform: "translate(23.464 5.349)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 4.329,
    height: 20.183,
    transform: "translate(17.51)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M57.393,43.986a.856.856,0,1,1-.856-.856A.856.856,0,0,1,57.393,43.986Z",
    transform: "translate(-36.772 -28.646)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 1.325,
    height: 8.248,
    transform: "translate(19.064 5.349)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 4.329,
    height: 20.183,
    transform: "translate(13.323)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M45.06,43.986a.856.856,0,1,1-.252-.607A.86.86,0,0,1,45.06,43.986Z",
    transform: "translate(-28.627 -28.646)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 1.325,
    height: 8.248,
    transform: "translate(14.877 5.349)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M19.747,22.971l5.2-17.753L23.155,4.43l-5.335,17.9Z",
    transform: "translate(-11.779 -3.097)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "success-animate",
    transform: "translate(-10829.043 -5587.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star-3",
    d: "M153.723,5.349a.6.6,0,0,0-.516-.382l-4.914-.4L145.837.292a.61.61,0,0,0-1.1.069l-1.9,4.549-4.824,1.014a.6.6,0,0,0-.467.445.613.613,0,0,0,.192.615l3.741,3.211-.527,4.9a.61.61,0,0,0,.926.585l4.211-2.563,4.5,2.016a.612.612,0,0,0,.843-.7L150.3,9.64l3.3-3.656A.6.6,0,0,0,153.723,5.349Z",
    transform: "translate(11376.561 5948.822)",
    fill: "#45d8ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star-2",
    d: "M114,349.772a.338.338,0,0,0-.291-.217l-2.785-.228-1.4-2.423a.346.346,0,0,0-.618.038l-1.077,2.579-2.747.574a.343.343,0,0,0-.275.253.349.349,0,0,0,.11.349l2.121,1.821-.261,2.777a.346.346,0,0,0,.525.332l2.387-1.453,2.549,1.143a.381.381,0,0,0,.165.03.365.365,0,0,0,.2-.08.346.346,0,0,0,.115-.346l-.646-2.719,1.876-2.071A.346.346,0,0,0,114,349.772Z",
    transform: "translate(11400.306 5697.32)",
    fill: "#45d8ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "star-1",
    d: "M389,50.716a.346.346,0,0,0-.294-.217l-2.788-.228-1.374-2.42a.338.338,0,0,0-.321-.173.346.346,0,0,0-.3.212l-1.077,2.577-2.733.574a.349.349,0,0,0-.275.253.341.341,0,0,0,.11.349l2.123,1.821-.3,2.777a.346.346,0,0,0,.159.33.338.338,0,0,0,.365,0l2.384-1.45,2.552,1.14a.335.335,0,0,0,.162.03.321.321,0,0,0,.2-.08.34.34,0,0,0,.118-.346l-.646-2.717,1.871-2.071A.341.341,0,0,0,389,50.716Z",
    transform: "translate(11200.82 5914.226)",
    fill: "#45d8ae"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle-cell",
    cx: 41.542,
    cy: 41.542,
    r: 41.542,
    transform: "translate(11511.797 5966.799)",
    fill: "#45d8ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "mark",
    d: "M185.92,157.269,200.8,183.722l38.966-44.042-38.043,27.7Z",
    transform: "translate(11341.463 5847.495)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBounce);
export default __webpack_public_path__ + "static/media/success-bounce.c71cf513f51dac144cbfbb4efb4118c4.svg";
export { ForwardRef as ReactComponent };